var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm.isRouterAlive ? [!_vm.isLogin ? _c('m-loading', {
    ref: "mLoadingRef",
    on: {
      "result": _vm.mLoadingResult
    }
  }) : [_c('layout')]] : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };